export default __webpack_public_path__ + "static/media/1.9644bba6.jpg";